var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2689 5.39913C16.2689 5.38956 16.2767 5.3818 16.2862 5.3818H18.3845C19.5528 5.3818 20.5563 4.40743 20.1937 3.29674C19.505 1.18712 17.6829 0 15.0156 0H5.98444C2.53556 0 0.5 1.98459 0.5 5.33847V12.6615C0.5 16.0154 2.53556 18 5.98444 18H15.0156C18.4644 18 20.5 16.0154 20.5 12.6615C20.5 12.4892 20.3603 12.3495 20.188 12.3495H16.2689C14.3052 12.3495 12.7133 10.7975 12.7133 8.883C12.7133 6.97416 14.2958 5.42566 16.2515 5.41651C16.261 5.41647 16.2689 5.40871 16.2689 5.39913ZM16.2689 6.87241H19.7533C20.1657 6.87241 20.5 7.1983 20.5 7.6004V10.131C20.4952 10.5311 20.1637 10.8543 19.7533 10.8589H16.3489C15.3548 10.872 14.4855 10.2084 14.26 9.2643C14.1471 8.6783 14.3056 8.0736 14.6931 7.6122C15.0805 7.1509 15.6573 6.88007 16.2689 6.87241ZM16.42 9.533H16.7489C17.1711 9.533 17.5133 9.1993 17.5133 8.7877C17.5133 8.3761 17.1711 8.0424 16.7489 8.0424H16.42C16.2181 8.0401 16.0236 8.1166 15.88 8.255C15.7364 8.3934 15.6555 8.5821 15.6556 8.779C15.6555 9.1921 15.9964 9.5282 16.42 9.533ZM5.23778 5.3818H10.8822C11.3044 5.3818 11.6467 5.04812 11.6467 4.63649C11.6467 4.22487 11.3044 3.89119 10.8822 3.89119H5.23778C4.81903 3.89116 4.4782 4.2196 4.47333 4.62783C4.47331 5.04087 4.81415 5.37705 5.23778 5.3818Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0eb7c6b79ae91b12e3d324571a8c6461.svg";
export { ForwardRef as ReactComponent };